<template>
  <div>
    <div class="white_bg">
      <div class="compare_models_top flex">
        <div class="compare_title flex">
          <div class="compare_title_left"></div>
          <div class="compare_title_text">对比车型</div>
        </div>
        <div class="compare_models flex">
          <div
            class="compare_model"
            v-for="(item, ind) in contrastList"
            :key="ind"
          >
            <div class="compare_model_img">
              <img :src="item.model_img" />
            </div>
            <div class="compare_model_name flex">
              <div class="compare_model_name_text">{{ item.model_name }}</div>
              <div
                v-if="contrastList.length > 1"
                class="compare_model_del_btn"
                @click="changeModel({ type: 'del', model_id: item.model_id })"
              ></div>
            </div>
          </div>
        </div>
        <!-- <div
          class="compare_model_add_btn"
          v-if="contrastList && contrastList.length < 3"
          @click.self="changeModel({ type: 'add' })"
        ></div> -->
        <div
          class="add_model_btn"
          v-if="contrastList && contrastList.length < 3"
          @click="changeModel({ type: 'add' })"
        >
          <span class="addIcon"></span>
          <span class="addText">对比车型</span>
        </div>
      </div>
      <div class="tabs flex">
        <div
          :class="['tab', 'tab_1', cur_tab_ind == 0 ? 'act' : '']"
          @click="changeTab(0)"
        >
          性能指标
        </div>
        <div
          :class="['tab', 'tab_1', cur_tab_ind == 1 ? 'act' : '']"
          @click="changeTab(1)"
        >
          功能指标
        </div>
        <div
          :class="['tab', 'tab_2', cur_tab_ind == 3 ? 'act' : '']"
          @click="changeTab(3)"
        >
          旅途指标
        </div>
        <div
          :class="['tab', 'tab_2', cur_tab_ind == 2 ? 'act' : '']"
          @click="changeTab(2)"
        >
          创新指标
        </div>
      </div>
      <div class="contents">
        <!-- 性能标杆分析 -->
        <div class="content" v-if="cur_tab_ind == 0">
          <div
            class="echarts_item"
            v-if="contrastList && contrastList.length > 0"
          >
            <LineChartComponent
              :node_id="l1_node_id_xn"
              :models="contrastList"
              @handel="l1_click_xn"
            />
          </div>
          <div class="echarts_item echarts_item1" v-if="l2_node_id_xn">
            <NodeName :node_name="l1_node_name_xn + '-' + l2_node_name_xn" />
            <LineChartComponent
              :node_id="l2_node_id_xn"
              :models="contrastList"
              @handel="l2_click_xn"
              @loadEnd="goAnthor('.echarts_item1')"
            />
          </div>
          <div class="echarts_item echarts_item2" v-if="l3_node_id_xn">
            <NodeName
              :node_name="
                l1_node_name_xn + '-' + l2_node_name_xn + '-' + l3_node_name_xn
              "
            />
            <LineChartComponent
              :node_id="l3_node_id_xn"
              :models="contrastList"
              @handel="l3_click_xn"
              @loadEnd="goAnthor('.echarts_item2')"
            />
          </div>

          <div
            class="tree_table_content echarts_item5"
            v-show="tree_table_data_xn"
          >
            <NodeName
              :node_name="
                l1_node_name_xn +
                '-' +
                l2_node_name_xn +
                '-' +
                l3_node_name_xn +
                '-' +
                l4_node_name_xn
              "
            />
            <div
              :style="
                'width:' + [790, 1000, 1230][contrastList.length - 1] + 'px;'
              "
            >
              <div
                class="model_list_box"
                :style="
                  'width:' + [770, 1000, 1230][contrastList.length - 1] + 'px;'
                "
              >
                <div
                  class="model_list_item model_list_attr"
                  style="width: 390px"
                >
                  车型信息
                </div>
                <template v-for="(item, ind) in contrastList" :key="ind">
                  <div class="model_list_item" style="width: 230px">
                    <div class="model_name">
                      {{ item.model_name }} ({{ item.review_model_id }})
                    </div>
                  </div>
                </template>
                <div></div>
              </div>
              <template v-if="tree_table_data_xn">
                <el-table
                  empty-text="暂无数据,敬请期待。"
                  v-loading="tree_table_loading_xn"
                  element-loading-text="计算得分中..."
                  :data="tree_table_data_xn"
                  row-key="node_id"
                  border
                  default-expand-all="true"
                  :tree-props="{ children: 'child' }"
                  :style="{
                    width: [770, 1000, 1230][contrastList.length - 1] + 'px',
                  }"
                >
                  <el-table-column
                    :resizable="false"
                    label="评测项"
                    width="390"
                    :show-overflow-tooltip="true"
                  >
                    <template #default="scope">
                      <span
                        class="level_tag"
                        v-if="
                          scope.row.is_leaf == 0 &&
                          scope.row.level > 0 &&
                          scope.row.level < 4
                        "
                        :style="{
                          background: ['#649FEB', '#65C57C', '#F29D65'][
                            scope.row.level - 1
                          ],
                        }"
                      >
                        {{
                          ["一", "二", "三", "四", "五", "六"][
                            scope.row.level - 1
                          ] + "级评测项"
                        }}
                      </span>
                      <span>
                        {{ scope.row.node_name || scope.row.name }}
                      </span>
                      <el-popover
                        v-if="
                          scope.row.child &&
                          Object.keys(scope.row.child).length == 0
                        "
                        :tabindex="-1"
                        placement="right"
                        :width="400"
                        trigger="hover"
                      >
                        <div class="rulePop" v-html="scope.row.node_desc"></div>
                        <template #reference>
                          <span
                            class="tip_icon"
                            @mouseenter="getRule(scope.row)"
                          ></span>
                        </template>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <template v-for="(item, index) in contrastList" :key="index">
                    <el-table-column
                      :resizable="false"
                      label="得分"
                      width="230"
                    >
                      <template #default="scope">
                        <template
                          v-if="
                            scope.row.is_leaf == 0 &&
                            scope.row.level > 0 &&
                            scope.row.level < 4
                          "
                        >
                          <tree-table-item
                            :data="{
                              type: 1,
                              score: scope.row.score[index],
                              total_score: scope.row.total_score[index],
                              width: '190px',
                            }"
                          ></tree-table-item>
                        </template>
                        <template
                          v-else-if="
                            scope.row.score[index] > -1 &&
                            scope.row.total_score[index] > 0
                          "
                        >
                          <tree-table-item
                            :data="{
                              type: 2,
                              score: scope.row.score[index],
                              total_score: scope.row.total_score[index],
                              width: '190px',
                            }"
                          ></tree-table-item>
                        </template>
                      </template>
                    </el-table-column>
                  </template>
                  <el-table-column
                    :resizable="false"
                    label="详情"
                    width="150"
                    class-name="td_class"
                  >
                    <template #default="scope">
                      <template v-if="scope.row.is_leaf == 0">
                        <!-- <span
                          class="appraise_one_tag"
                          v-if="scope.row.level == 1"
                          @click="getEvaluation(scope.row, '专家综合评价')"
                        >
                          专家综合评价
                        </span>
                        <span
                            class="appraise_two_tag"
                            v-else-if="scope.row.level == 2"
                            @click="getEvaluation(scope.row, '专家评价')"
                          >
                            专家评价
                          </span>
                        <span v-else> </span> -->
                        <span></span>
                      </template>
                      <span
                        class="detail_tag"
                        v-else
                        @click="
                          getDetail(scope.row);
                          showRuleDesc = false;
                        "
                      >
                        详情
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </div>
          </div>
        </div>
        <!-- 功能标杆分析 -->
        <div class="content" v-if="cur_tab_ind == 1">
          <div
            class="echarts_item"
            v-if="contrastList && contrastList.length > 0"
          >
            <LineChartComponent
              :node_id="l1_node_id_gn"
              :models="contrastList"
              @handel="l1_click_gn"
            />
          </div>
          <div class="echarts_item echarts_item11" v-if="l2_node_id_gn">
            <NodeName :node_name="l1_node_name_gn + '-' + l2_node_name_gn" />
            <LineChartComponent
              :node_id="l2_node_id_gn"
              :models="contrastList"
              @handel="l2_click_gn"
              @loadEnd="goAnthor('.echarts_item11')"
            />
          </div>

      
          <div
            class="tree_table_content echarts_item3"
            v-show="tree_table_data_gn"
          >
            <NodeName
              :node_name="
                l1_node_name_gn + '-' + l2_node_name_gn + '-' + l3_node_name_gn
              "
            />
            <div
              :style="
                'width:' + [790, 1000, 1230][contrastList.length - 1] + 'px;'
              "
            >
              <div
                class="model_list_box"
                :style="
                  'width:' + [770, 1000, 1230][contrastList.length - 1] + 'px;'
                "
              >
                <div
                  class="model_list_item model_list_attr"
                  style="width: 390px"
                >
                  车型信息
                </div>
                <template v-for="(item, ind) in contrastList" :key="ind">
                  <div class="model_list_item" style="width: 230px">
                    <div class="model_name">
                      {{ item.model_name }} ({{ item.review_model_id }})
                    </div>
                  </div>
                </template>
                <div></div>
              </div>
              <template v-if="tree_table_data_gn">
                <el-table
                  empty-text="暂无数据,敬请期待。"
                  v-loading="tree_table_loading_gn"
                  element-loading-text="计算得分中..."
                  :data="tree_table_data_gn"
                  row-key="node_id"
                  border
                  default-expand-all="true"
                  :tree-props="{ children: 'child' }"
                  :style="{
                    width: [770, 1000, 1230][contrastList.length - 1] + 'px',
                  }"
                >
                  <el-table-column
                    :resizable="false"
                    label="评测项"
                    width="390"
                    :show-overflow-tooltip="true"
                  >
                    <template #default="scope">
                      <span
                        class="level_tag"
                        v-if="
                          scope.row.is_leaf == 0 &&
                          scope.row.level > 0 &&
                          scope.row.level < 4
                        "
                        :style="{
                          background: ['#649FEB', '#65C57C', '#F29D65'][
                            scope.row.level - 1
                          ],
                        }"
                      >
                        {{
                          ["一", "二", "三", "四", "五", "六"][
                            scope.row.level - 1
                          ] + "级评测项"
                        }}
                      </span>
                      <span>
                        {{ scope.row.node_name || scope.row.name }}
                      </span>
                      <el-popover
                        v-if="
                          scope.row.child &&
                          Object.keys(scope.row.child).length == 0
                        "
                        :tabindex="-1"
                        placement="right"
                        :width="400"
                        trigger="hover"
                      >
                        <div class="rulePop" v-html="scope.row.node_desc"></div>
                        <template #reference>
                          <span
                            class="tip_icon"
                            @mouseenter="getRule(scope.row)"
                          ></span>
                        </template>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <template v-for="(item, index) in contrastList" :key="index">
                    <el-table-column
                      :resizable="false"
                      label="得分"
                      width="230"
                    >
                      <template #default="scope">
                        <template
                          v-if="
                            scope.row.is_leaf == 0 &&
                            scope.row.level > 0 &&
                            scope.row.level < 4
                          "
                        >
                          <tree-table-item
                            :data="{
                              type: 1,
                              score: scope.row.score[index],
                              total_score: scope.row.total_score[index],
                              width: '190px',
                            }"
                          ></tree-table-item>
                        </template>
                        <template
                          v-else-if="
                            scope.row.score[index] > -1 &&
                            scope.row.total_score[index] > 0
                          "
                        >
                          <tree-table-item
                            :data="{
                              type: 2,
                              score: scope.row.score[index],
                              total_score: scope.row.total_score[index],
                              width: '190px',
                            }"
                          ></tree-table-item>
                        </template>
                      </template>
                    </el-table-column>
                  </template>
                  <el-table-column
                    :resizable="false"
                    label="详情"
                    width="150"
                    class-name="td_class"
                  >
                    <template #default="scope">
                      <template v-if="scope.row.is_leaf == 0">
                        <span
                          class="appraise_one_tag"
                          v-if="scope.row.level == 1"
                          @click="getEvaluation(scope.row, '专家综合评价')"
                        >
                          专家综合评价
                        </span>
                        <!-- <span
                            class="appraise_two_tag"
                            v-else-if="scope.row.level == 2"
                            @click="getEvaluation(scope.row, '专家评价')"
                          >
                            专家评价
                          </span> -->
                        <span v-else></span>
                      </template>
                      <span
                        class="detail_tag"
                        v-else
                        @click="
                          getDetail(scope.row);
                          showRuleDesc = false;
                        "
                      >
                        详情
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </div>
          </div>
        </div>
        <!-- 创新标杆分析 -->
        <div class="content" v-show="cur_tab_ind == 2">
          <div class="echarts_item">
            <v-chart
              ref="innovateChartRef"
              class="bar_chart"
              :option="barOptions"
              style="width: 1100px; height: 300px"
              autoresize
              :loading="barLoading"
              :loadingOptions="barLoadingOptions"
              @click="innovateClick"
            />
          </div>
          <div class="analyse_item analyse_item_table analyse_item_table3">
            <div class="tree_table_content" v-if="innovate_treetable_data">
              <div
                class="model_list_box"
                :style="
                  'width:' + [790, 1000, 1230][contrastList.length - 1] + 'px;'
                "
              >
                <div
                  class="model_list_item model_list_attr"
                  style="width: 390px"
                >
                  车型信息
                </div>
                <template v-for="(item, ind) in contrastList" :key="ind">
                  <div class="model_list_item" style="width: 230px">
                    <div class="model_name">
                      {{ item.model_name }} ({{ item.review_model_id }})
                    </div>
                  </div>
                </template>
                <div></div>
              </div>
              <el-table
                empty-text="暂无数据,敬请期待。"
                :loading="innovate_treetable_loading"
                element-loading-text="计算得分中..."
                :data="innovate_treetable_data"
                :style="{
                  width: [790, 1000, 1230][contrastList.length - 1] + 'px',
                }"
                row-key="node_id"
                border
                default-expand-all="true"
                :tree-props="{ children: 'child' }"
                :span-method="objectSpanMethod"
              >
                <el-table-column
                  :resizable="false"
                  label="评测项"
                  width="390"
                  :show-overflow-tooltip="true"
                >
                  <template #default="scope">
                    <span
                      class="level_tag"
                      v-if="
                        tab_select == 4
                          ? scope.row.node_id < 4
                          : scope.row.is_leaf == 0 &&
                            scope.row.level > 0 &&
                            scope.row.level < 4
                      "
                      :style="{
                        background:
                          tab_select == 4
                            ? '#649FEB'
                            : ['#649FEB', '#65C57C', '#F29D65'][
                                scope.row.level - 1
                              ],
                      }"
                    >
                      {{
                        tab_select == 4
                          ? "创新类型"
                          : ["一", "二", "三", "四", "五", "六"][
                              scope.row.level - 1
                            ] + "级评测项"
                      }}
                    </span>
                    <span>
                      {{ scope.row.node_name || scope.row.name }}
                    </span>
                    <el-popover
                      v-if="
                        scope.row.child &&
                        Object.keys(scope.row.child).length == 0
                      "
                      :tabindex="-1"
                      placement="right"
                      :width="400"
                      trigger="hover"
                    >
                      <div class="rulePop" v-html="scope.row.node_desc"></div>
                      <template #reference>
                        <span
                          class="tip_icon"
                          @mouseenter="getRule(scope.row)"
                        ></span>
                      </template>
                    </el-popover>
                  </template>
                </el-table-column>
                <template v-if="contrastList && contrastList.length > 0">
                  <template v-for="(item, index) in contrastList" :key="index">
                    <el-table-column
                      :resizable="false"
                      label="得分"
                      width="230"
                    >
                      <template #default="scope">
                        <template
                          v-if="
                            scope.row.node_id < 4 &&
                            scope.row.name.indexOf('创新') > -1
                          "
                        >
                          <tree-table-item
                            :data="{
                              type: 4,
                              score: scope.row.score[index],
                              total_score: scope.row.total_score[index],
                              width: '190px',
                            }"
                          ></tree-table-item>
                        </template>
                        <template
                          v-else-if="
                            scope.row.score[index] > -1 &&
                            scope.row.total_score[index] > 0
                          "
                        >
                          <tree-table-item
                            :data="{
                              type: 2,
                              score: scope.row.score[index],
                              total_score: scope.row.total_score[index],
                              width: '190px',
                            }"
                          ></tree-table-item>
                        </template>
                      </template>
                    </el-table-column>
                  </template>
                </template>

                <el-table-column
                  :resizable="false"
                  label="详情"
                  width="150"
                  class-name="td_class"
                >
                  <template #default="scope">
                    <span
                      class="detail_tag"
                      v-if="!scope.row.child"
                      @click="getInnovateDetailV2Info(scope.row)"
                    >
                      专家评价
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <!-- 旅途标杆分析 -->
        <div class="content" v-if="cur_tab_ind == 3">
          <div
            class="echarts_item"
            v-if="contrastList && contrastList.length > 0"
          >
            <LineChartComponent
              :node_id="l1_node_id_lt"
              :models="contrastList"
              @handel="l1_click_lt"
            />
          </div>
          <div class="echarts_item echarts_item7" v-if="l2_node_id_lt">
            <NodeName :node_name="l1_node_name_lt + '-' + l2_node_name_lt" />
            <LineChartComponent
              :node_id="l2_node_id_lt"
              :models="contrastList"
              @handel="l2_click_lt"
              @loadEnd="goAnthor('.echarts_item7')"
            />
          </div>
          <div class="echarts_item echarts_item8" v-if="l3_node_id_lt">
            <NodeName
              :node_name="
                l1_node_name_lt + '-' + l2_node_name_lt + '-' + l3_node_name_lt
              "
            />
            <LineChartComponent
              :node_id="l3_node_id_lt"
              :models="contrastList"
              @handel="l3_click_lt"
              @loadEnd="goAnthor('.echarts_item8')"
            />
          </div>

          <div
            class="tree_table_content echarts_item9"
            v-show="tree_table_data_lt"
          >
            <NodeName
              :node_name="
                l1_node_name_lt +
                '-' +
                l2_node_name_lt +
                '-' +
                l3_node_name_lt +
                '-' +
                l4_node_name_lt
              "
            />
            <div
              :style="
                'width:' + [790, 1000, 1230][contrastList.length - 1] + 'px;'
              "
            >
              <div
                class="model_list_box"
                :style="
                  'width:' + [770, 1000, 1230][contrastList.length - 1] + 'px;'
                "
              >
                <div
                  class="model_list_item model_list_attr"
                  style="width: 390px"
                >
                  车型信息
                </div>
                <template v-for="(item, ind) in contrastList" :key="ind">
                  <div class="model_list_item" style="width: 230px">
                    <div class="model_name">
                      {{ item.model_name }} ({{ item.review_model_id }})
                    </div>
                  </div>
                </template>
                <div></div>
              </div>
              <template v-if="tree_table_data_lt">
                <el-table
                  empty-text="暂无数据,敬请期待。"
                  v-loading="tree_table_loading_xn"
                  element-loading-text="计算得分中..."
                  :data="tree_table_data_lt"
                  row-key="node_id"
                  border
                  default-expand-all="true"
                  :tree-props="{ children: 'child' }"
                  :style="{
                    width: [770, 1000, 1230][contrastList.length - 1] + 'px',
                  }"
                >
                  <el-table-column
                    :resizable="false"
                    label="评测项"
                    width="390"
                    :show-overflow-tooltip="true"
                  >
                    <template #default="scope">
                      <span
                        class="level_tag"
                        v-if="
                          scope.row.is_leaf == 0 &&
                          scope.row.level > 0 &&
                          scope.row.level < 4
                        "
                        :style="{
                          background: ['#649FEB', '#65C57C', '#F29D65'][
                            scope.row.level - 1
                          ],
                        }"
                      >
                        {{
                          ["一", "二", "三", "四", "五", "六"][
                            scope.row.level - 1
                          ] + "级评测项"
                        }}
                      </span>
                      <span>
                        {{ scope.row.node_name || scope.row.name }}
                      </span>
                      <el-popover
                        v-if="
                          scope.row.child &&
                          Object.keys(scope.row.child).length == 0
                        "
                        :tabindex="-1"
                        placement="right"
                        :width="400"
                        trigger="hover"
                      >
                        <div class="rulePop" v-html="scope.row.node_desc"></div>
                        <template #reference>
                          <span
                            class="tip_icon"
                            @mouseenter="getRule(scope.row)"
                          ></span>
                        </template>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <template v-for="(item, index) in contrastList" :key="index">
                    <el-table-column
                      :resizable="false"
                      label="得分"
                      width="230"
                    >
                      <template #default="scope">
                        <template
                          v-if="
                            scope.row.is_leaf == 0 &&
                            scope.row.level > 0 &&
                            scope.row.level < 4
                          "
                        >
                          <tree-table-item
                            :data="{
                              type: 1,
                              score: scope.row.score[index],
                              total_score: scope.row.total_score[index],
                              width: '190px',
                            }"
                          ></tree-table-item>
                        </template>
                        <template
                          v-else-if="
                            scope.row.score[index] > -1 &&
                            scope.row.total_score[index] > 0
                          "
                        >
                          <tree-table-item
                            :data="{
                              type: 2,
                              score: scope.row.score[index],
                              total_score: scope.row.total_score[index],
                              width: '190px',
                            }"
                          ></tree-table-item>
                        </template>
                      </template>
                    </el-table-column>
                  </template>
                  <el-table-column
                    :resizable="false"
                    label="详情"
                    width="150"
                    class-name="td_class"
                  >
                    <template #default="scope">
                      <template v-if="scope.row.is_leaf == 0">
                        <!-- <span
                          class="appraise_one_tag"
                          v-if="scope.row.level == 1"
                          @click="getEvaluation(scope.row, '专家综合评价')"
                        >
                          专家综合评价
                        </span>
                        <span
                            class="appraise_two_tag"
                            v-else-if="scope.row.level == 2"
                            @click="getEvaluation(scope.row, '专家评价')"
                          >
                            专家评价
                          </span>
                        <span v-else> </span> -->
                        <span></span>
                      </template>
                      <span
                        class="detail_tag"
                        v-else
                        @click="
                          getDetail(scope.row);
                          showRuleDesc = false;
                        "
                      >
                        详情
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 测评详情表格弹窗 -->
    <el-drawer
      v-model="dialogVisible"
      :title="node_name"
      direction="rtl"
      :before-close="handleClose"
      :size="'auto'"
      modal-class="modal_transparent"
    >
      <div class="my_dialog" v-if="dialogVisible">
        <table class="detail_table" border="1">
          <tr class="detail_title">
            <td class="detail_attr">车型</td>
            <template v-for="(item, ind) in contrastList" :key="ind">
              <td class="detail_title_item" colspan="1">
                {{ item.model_name }}
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item" v-show="showRuleDesc == true">
            <td class="detail_attr">
              标准
              <span id="triangle-up" @click="showRuleDesc = false"></span>
            </td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  class="detail_val_text"
                  v-html="(item['9'] && item['9']) || '暂无'"
                ></div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <!-- 背景色占位 -->
          </tr>
          <tr class="detail_tr_item" v-show="showRuleDesc == false">
            <td class="detail_attr">
              标准
              <span id="triangle-down" @click="showRuleDesc = true"></span>
            </td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 5px;
                  "
                  class="detail_val_text"
                  v-html="(item['9'] && item['9']) || '暂无'"
                ></div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">
              <div>得分</div>
            </td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div class="attr_box">
                  <!-- <div class="attr_node_name">
                  {{ node_name }}
                </div> -->
                  <div class="attr_node_score">
                    <span class="attr_node_score_num" style="color: #f00"
                      >{{
                        (item["1"] && item["1"].item_value_val) || 0
                      }}分</span
                    >
                  </div>
                </div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">主观评价</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  class="detail_val_text"
                  v-html="(item['2'] && item['2'].item_value_val) || '暂无'"
                ></div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">客观信息</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <div
                  class="detail_val_text"
                  v-html="(item['3'] && item['3'].item_value_val) || '暂无'"
                ></div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">图片素材</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <template v-if="item['4'] && item['4'].ext_info.length > 0">
                  <div class="detail_val_pic">
                    <div
                      class="detail_pic_left"
                      @click.stop="
                        previewImg(item['4'] && item['4'].ext_info, 'img')
                      "
                    >
                      <div class="detail_pic_left_img">
                        <img
                          :src="item['4'].ext_info[0].attach_value || ''"
                          alt="图片加载失败"
                        />
                        <span class="more_pic">{{
                          item["4"] && item["4"].ext_info.length
                        }}</span>
                      </div>
                      <div class="look_pic">点击查看图片</div>
                    </div>
                    <div
                      class="detail_pic_right detail_val_text"
                      v-if="item['4'] && item['4'].item_value_val"
                      v-html="item['4'] && item['4'].item_value_val"
                    ></div>
                  </div>
                  <div class="download_btn" v-if="store.getDownloadAuth()" @click="downloadFn(item['4'] && item['4'].ext_info,contrastList[ind].model_name,node_name)"></div>
                </template>
                <div class="no_img" v-else>
                  当前测试子节点本次未涉及图片素材
                </div>
              </td>
            </template>
          </tr>
          <tr class="detail_tr_item">
            <td class="detail_attr">视频素材</td>
            <template v-for="(item, ind) in detail_list" :key="ind">
              <td class="detail_val">
                <template v-if="item['5'] && item['5'].ext_info.length > 0">
                  <div class="detail_val_video">
                    <div
                      class="detail_video_left"
                      @click.stop="
                        previewImg(item['5'] && item['5'].ext_info, 'video')
                      "
                    >
                      <div class="detail_pic_left_video">
                        <video
                          :src="item['5'].ext_info[0].attach_value"
                          :poster="
                            item['5'].ext_info[0].attach_value +
                            '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'
                          "
                          preload="none"
                        ></video>
                        <span class="more_pic">{{
                          item["5"] && item["5"].ext_info.length
                        }}</span>
                      </div>
                      <div class="look_pic">点击查看视频</div>
                    </div>
                    <div
                      class="detail_pic_right detail_val_text"
                      v-if="item['5'] && item['5'].item_value_val"
                      v-html="item['5'] && item['5'].item_value_val"
                    ></div>
                  </div>
                  <div class="download_btn" v-if="store.getDownloadAuth()" @click="downloadFn(item['5'] && item['5'].ext_info,contrastList[ind].model_name,node_name)"></div>
                </template>
                <div class="no_img" v-else>
                  当前测试子节点本次未涉及视频素材
                </div>
              </td>
            </template>
          </tr>
        </table>
      </div>
    </el-drawer>
    <!-- 专家评价表格弹窗 -->
    <el-drawer
      v-model="descDrawer"
      title=""
      direction="rtl"
      :before-close="handleClose"
      :size="'auto'"
      modal-class="modal_transparent"
    >
      <div
        class="one_evaluation_desc"
        v-if="evaluation_list && evaluation_list.length == 1"
      >
        <div class="one_desc_tit">
          {{ evaluation_list[0].node_name }}-专家综合评价
        </div>
        <div
          class="one_desc_desc"
          v-html="evaluation_list[0].node_value.content"
        ></div>
      </div>
      <div class="more_evaluation_desc" v-else>
        <table class="table3">
          <tr>
            <td v-for="(item, ind) in contrastList" :key="ind">
              <div class="table3_model_name">
                {{ item.model_name }}专家综合评价
              </div>
            </td>
          </tr>
          <tr>
            <td
              class="table_bd_left"
              v-for="(item, ind) in contrastList"
              :key="ind"
            >
              <div class="table_title_text">评价主体</div>
            </td>
          </tr>
          <tr>
            <td
              class="table_bd_left"
              v-for="(item, ind) in contrastList"
              :key="ind"
            >
              <div class="table3_model_desc">
                <div
                  class="table3_model_content"
                  v-if="
                    evaluation_list[ind] &&
                    evaluation_list[ind].node_value &&
                    evaluation_list[ind].node_value.content
                  "
                  v-html="evaluation_list[ind].node_value.content"
                ></div>
                <div
                  class="table3_model_experts"
                  v-if="evaluation_list[ind].node_value.evaluator"
                >
                  评价专家:{{ evaluation_list[ind].node_value.evaluator }}
                </div>
                <div
                  class="table3_model_time"
                  v-if="evaluation_list[ind].node_value.evaluate_time"
                >
                  {{
                    timestampToString(
                      evaluation_list[ind].node_value.evaluate_time
                    )
                  }}
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </el-drawer>
    <!-- 创新专家评价 -->
    <el-drawer
      v-model="drawer"
      :title="innovate_detail_list_cur_type"
      direction="rtl"
      :before-close="handleClose"
      :size="'auto'"
      modal-class="modal_transparent"
    >
      <div class="my_dialog">
        <table class="detail_table2">
          <tr class="table_tit">
            <td
              class="table_tit_item"
              v-if="
                !(contrastList.length == 1 || innovate_detail_list.length == 1)
              "
            >
              车型信息
            </td>
            <!-- <td class="table_tit_item">对应二级功能指标</td> -->
            <!-- <td class="table_tit_item">创新分类</td> -->
            <td class="table_tit_item">创新项目</td>
            <td class="table_tit_item">创新维度评分</td>
            <td class="table_tit_item">综合得分</td>
            <td class="table_tit_item">图片素材</td>
            <td class="table_tit_item">视频素材</td>
            <td class="table_tit_item">创新项目主观评价</td>
          </tr>

          <template
            v-for="(list_item, list_ind) in innovate_detail_list"
            :key="list_ind"
          >
            <template v-for="(item, ind) in list_item" :key="ind">
              <tr class="table_tr">
                <template v-if="item">
                  <td
                    class="table_tr_td"
                    v-if="
                      !(
                        contrastList.length == 1 ||
                        innovate_detail_list.length == 1
                      ) && ind == 0
                    "
                    :rowspan="list_item.length"
                  >
                    <div class="td_model_info">
                      <div class="table_model_img" v-if="list_item.model_img">
                        <img
                          :src="list_item.model_img || ''"
                          alt="图片加载失败"
                        />
                      </div>
                      <div class="table_model_name">
                        {{ list_item.model_name }}
                      </div>
                    </div>
                  </td>
                  <!-- <td
                  class="table_tr_td table_tr_td_hebing"
                  v-if="item.hebing"
                  :rowspan="item.hebing"
                >
                  <div class="td_node_two td_text_bold">
                    {{ item.review_tree_name || "" }}
                  </div>
                </td> -->

                  <!-- <td
                  class="table_tr_td table_tr_td_hebing"
                  v-if="list_ind == innovate_first_key && ind == 0"
                  rowspan="999"
                >
                  <div class="td_node_two td_text_bold">
                    {{ innovate_detail_list_cur_type }}
                  </div>
                </td> -->

                  <td class="table_tr_td">
                    <div class="td_node_name td_text_bold">
                      {{ item.node_name }}
                    </div>
                  </td>
                  <td class="table_tr_td">
                    <div class="td_score table_text">
                      <p>惊喜：{{ item.surprise_score || 0 }}分</p>
                      <p>实用：{{ item.practical_score || 0 }}分</p>
                      <p>独创：{{ item.originality_score || 0 }}分</p>
                    </div>
                  </td>
                  <td class="table_tr_td">
                    <div class="td_score_two">
                      {{ item.synthetical_score || 0 }}分
                    </div>
                  </td>
                  <td class="table_tr_td detail_val">
                    <template v-if="item.item['3'] && item.item['3'].ext_info.length > 0">
                      <div class="detail_val_pic">
                        <div
                          class="detail_pic_left"
                          @click.stop="
                            previewImg(
                              item.item['3'] && item.item['3'].ext_info,
                              'img'
                            )
                          "
                        >
                          <div class="detail_pic_left_img">
                            <img
                              :src="item.item['3'].ext_info[0].attach_value || ''"
                              alt="图片加载失败"
                            />
                            <span class="more_pic">{{
                              item.item["3"] && item.item["3"].ext_info.length
                            }}</span>
                          </div>
                          <div class="look_pic">点击查看图片</div>
                        </div>
                        <div
                          class="detail_pic_right detail_val_text"
                          v-if="item.item['3'] && item.item['3'].item_value_val"
                          v-html="item.item['3'] && item.item['3'].item_value_val"
                        ></div>
                      </div>
                      <div class="download_btn" v-if="store.getDownloadAuth()" @click="downloadFn(item.item['3'] && item.item['3'].ext_info,list_item.model_name,innovate_detail_list_cur_type)"></div>
                    </template>
                    <div class="no_img" v-else>
                      当前测试子节点本次未涉及图片素材
                    </div>
                  </td>
                  <td class="table_tr_td detail_val">
                    
                    <template v-if="item.item['4'] && item.item['4'].ext_info.length > 0">
                      <div class="detail_val_video">
                        <div
                          class="detail_video_left"
                          @click.stop="
                            previewImg(
                              item.item['4'] && item.item['4'].ext_info,
                              'video'
                            )
                          "
                        >
                          <div class="detail_pic_left_video">
                            <video
                              :src="item.item['4'].ext_info[0].attach_value"
                              :poster="
                                item.item['4'].ext_info[0].attach_value +
                                '?spm=qipa250&x-oss-process=video/snapshot,t_1000,f_jpg,w_0,h_0,m_fast'
                              "
                              preload="none"
                            ></video>
                            <span class="more_pic">{{
                              item.item["4"] && item.item["4"].ext_info.length
                            }}</span>
                          </div>
                          <div class="look_pic">点击查看视频</div>
                        </div>
                        <div
                          class="detail_pic_right detail_val_text"
                          v-if="item.item['4'] && item.item['4'].item_value_val"
                          v-html="item.item['4'] && item.item['4'].item_value_val"
                        ></div>
                      </div>
                      <div class="download_btn" v-if="store.getDownloadAuth()" @click="downloadFn(item.item['4'] && item.item['4'].ext_info,list_item.model_name,innovate_detail_list_cur_type)"></div>
                    </template>
                    <div class="no_img" v-else>
                      当前测试子节点本次未涉及视频素材
                    </div>
                  </td>

                  <td class="table_tr_td">
                    <div class="td_evaluation table_text">
                      <template
                        v-for="(p_item, p_ind) in item.item"
                        :key="p_ind"
                      >
                        <p
                          v-if="
                            p_item.item_value_val &&
                            p_item.item_value_type != 4 &&
                            p_item.item_value_type != 5
                          "
                          v-html="p_item.item_value_val"
                        ></p>
                      </template>
                    </div>
                  </td>
                </template>
              </tr>
            </template>
          </template>
        </table>
      </div>
    </el-drawer>
    <!-- 图片视频swiper -->
    <div class="my_swiper_dialog" v-if="swiperVisible">
      <div class="my_swiper_dialog_content">
        <div class="my_swiper_dialog_close" @click="closeSwiperDialog"></div>

        <swiper :list="preview_list" :type="preview_type" />
      </div>
    </div>
  </div>
</template>
<script>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import store from "@/store";
import VChart from "vue-echarts";
import {
  ElMessage,
  ElTable,
  ElTableColumn,
  ElDrawer,
  ElPopover,
} from "element-plus";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart, BarChart } from "echarts/charts";
import TreeTableItem from "@/components/common/views/treeTable/TreeTableItem.vue";
import Swiper from "@/components/swiper/Swiper.vue";
import LineChartComponent from "@/components/v2/echarts/BarChartComponent.vue";
import NodeName from "@/components/common/views/NodeName.vue";
import {
  LegendComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
} from "echarts/components";
use([
  CanvasRenderer,
  LineChart,
  LegendComponent,
  TooltipComponent,
  GridComponent,
  ToolboxComponent,
  BarChart,
]);

import {
  getCarSummaryDataV2,
  // getNodeLineTwoDetail,
  getCarScoreV2,
  getCarScoreInnovateV2,
  getTestDetailV2,
  getInnovateDetailV2,
} from "@/api";

export default {
  name: "MultiAnalyse",
  components: {
    VChart,
    ElTable,
    ElTableColumn,
    TreeTableItem,
    ElDrawer,
    ElPopover,
    Swiper,
    LineChartComponent,
    NodeName,
  },
  setup() {
    const router = useRouter();
    // 车型对比：车型列表数据
    const contrastList = computed(() => store.state.compareCarDataV2);
    // tab切换 功能 or 创新
    const cur_tab_ind = ref(0);
    const changeTab = (ind) => {
      cur_tab_ind.value = ind;
    };
    // 进入页面请求数据
    const _getData = () => {
      let promiseCompareDataList = contrastList.value.map((item) => {
        return new Promise((resolve, reject) => {
          getCarSummaryDataV2({
            model_id: item.model_id,
          })
            .then((res) => {
              resolve(res);
            })
            .catch((res) => {
              reject(res);
            });
        });
      });
      Promise.all(promiseCompareDataList).then((res) => {
        let data = [];
        if (res && res.length > 0) {
          for (let item of res) {
            if (item.code == 200) {
              data = data || [];
              data.push(item.data);
            }
          }
          if (data && data.length > 0) {
            setChartData(data);
          }
        }
      });
    };
    _getData();

    const levelOneChartRef = ref(null);
    const xn_levelOneChartRef = ref(null);

    const innovateChartRef = ref(null);
    let levelOneNodes = {}; //一级标杆折线图的所有nodename:node_id
    let innovationNodes = {}; //创新标杆折线图的所有nodename:node_id
    const setChartData = (data) => {
      const barName = [];
      const lineName = [];
      const legendName = [];
      // 折线图所需
      const lineValue = [];
      // 条形图所需
      let barValue = [];
      // 折线图 性能
      const lineName2 = [];
      const lineValue2 = [];
      // let barNodes = [];
      for (let [index, car] of data.entries()) {
        legendName.push({
          name:car.short_name || car.model_name,
          icon: "rect",
        });
        //条形图所需
        const function_score_detail = car.function_score_detail;
        const carLineValue = {
          name:car.short_name || car.model_name,
          type: "line",
          data: [],
          symbol: "circle",
          symbolSize: 8,
          animation: false,
          label: {
            show: true,
          },
        };
        for (let item of function_score_detail) {
          if (index == 0) {
            levelOneNodes[item.node_name] = item.node_id;
            lineName.push(item.node_name);
          }

          item.score_percentage = (
            (item.score / item.total_score) *
            100
          ).toFixed(1);

          carLineValue.data.push({
            label: {
              color: "#404248",
              fontSize: 12,
              formatter: () => {
                return item.score_percentage + "%";
              },
            },
            value: item.score_percentage,
          });
        }
        lineValue.push(carLineValue);
        // 条形图 性能
        //条形图所需
        const performance_score_detail = car.performance_score_detail;
        const carLineValue2 = {
          name:car.short_name || car.model_name,
          type: "line",
          data: [],
          symbol: "circle",
          symbolSize: 8,
          animation: false,
          label: {
            show: true,
          },
        };
        for (let item of performance_score_detail) {
          if (index == 0) {
            levelOneNodes[item.node_name] = item.node_id;
            lineName2.push(item.node_name);
          }

          item.score_percentage = (
            (item.score / item.total_score) *
            100
          ).toFixed(1);

          carLineValue2.data.push({
            label: {
              color: "#404248",
              fontSize: 12,
              formatter: () => {
                return item.score_percentage + "%";
              },
            },
            value: item.score_percentage,
          });
        }
        lineValue2.push(carLineValue2);
        //柱状图所需
        const innovate_score_detail = car.innovate_score_detail;
        const carBarValue = {
          name: car.short_name || car.model_name,
          type: "bar",
          data: [],
          barMinHeight: 5,
          barWidth:25,
          emphasis: {
            focus: "series",
          },
          // barGap: 0, //柱子之间的距离
        };
        const carInnovateNode = [];
        for (let item of innovate_score_detail) {
          if (barName.indexOf(item.node_name) < 0) {
            innovationNodes[item.node_name] = item.type;
            barName.push(item.node_name);
            // barNodes.push({ node_name: item.node_name, type: item.type });
          }
          carBarValue.data.push(item.total_score);
          carInnovateNode.push({
            node_name: item.node_name,
            value: item.total_score,
          });
        }
        //该车型存在创新项 比其他车型创新项少的情况
        if (carInnovateNode.length != barName.length) {
          for (let [index, item] of carInnovateNode.entries()) {
            //存在
            if (barName.indexOf(item.node_name) > -1) {
              carBarValue.data[index] = item.value;
            } else {
              carBarValue.data[index] = 0;
            }
          }
        }
        barValue.push(carBarValue);
      }
      barValue = barValue.map((item) => {
        if (item.data.length < barName.length) {
          const len = item.data.length;
          item.data.length = barName.length;
          item.data.fill(0, len);
        }
        return item;
      });
      // levelOneChartRef.value.clear();
      innovateChartRef.value.clear();
      // xn_levelOneChartRef.value.clear();
      setLineChartOptions(legendName, lineName, lineValue);
      setLineChartOptions(legendName, lineName2, lineValue2, true);
      setBarChartOptions(legendName, barName, barValue);
    };
    // echarts 折线图 一级指标
    const lineOptions = ref(null);
    const lineLoading = ref(true);
    const lineLoadingOptions = ref({
      text: "Loading…",
      color: "#4ea397",
      maskColor: "rgba(255, 255, 255, 0.4)",
    });
    // 性能 一级
    const xn_lineOptions = ref(null);
    const xn_lineLoading = ref(true);
    // echarts 条形图 创新指标得分
    const barOptions = ref(null);
    const barLoading = ref(false);
    const barLoadingOptions = ref({
      text: "Loading…",
      color: "#4ea397",
      maskColor: "rgba(255, 255, 255, 0.4)",
    });

    const setLineChartOptions = (legendName, lineName, lineValue, is_xn) => {
      let options = {
        tooltip: {
          trigger: "axis",
          enterable: true,
          confine: true,
          backgroundColor: "rgba(37, 34, 69, 0.8)",
          transitionDuration: 1,
          padding: [20, 30, 17, 30],
          position: function (point) {
            // 固定在顶部
            return [point[0], "20%"];
          },
          textStyle: {
            color: "#fff",
            fontSize: 14,
            lineHeight: 16,
          },
        },
        legend: {
          data: legendName,
          left: "center",
          itemWidth: 11,
          itemHeight: 11,
          itemGap: 25,
          itemStyle: {
            fontSize: 12,
          },
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: lineName,
          nameLocation: "center",
          nameTextStyle: {
            color: "#404248",
            fontSize: 16,
          },
          axisLine: {
            lineStyle: {
              // color: "#b9c2da",
              width: "1", //坐标线的宽度
            },
          },
          axisLabel: {
                        color:"#2192ff",
            fontSize: 12,
          },
          offset: 20,
          triggerEvent: true,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#404248",
            fontSize: 12,
            padding: [0, 15, 0, 0],
            formatter: "{value} %",
          },
          splitLine: {
            lineStyle: {
              color: "#edf2fe",
            },
          },
          splitNumber: 5,
          min: function (value) {
            return Math.floor(value.min / 10) * 10;
          },
          max: function (value) {
            return (Math.floor(value.max / 10) + 1) * 10 > 100
              ? 100
              : (Math.floor(value.max / 10) + 1) * 10;
          },
          interval: 20,
        },
        series: lineValue,
      };
      if (is_xn) {
        xn_lineOptions.value = options;
      } else {
        lineOptions.value = options;
      }
      xn_lineLoading.value = false;
      barLoading.value = false;
      lineLoading.value = false;
    };
    let levelTwoNodes = {};
    const levelOneClick = (param) => {
      lineLoading2.value = true;
      tree_table_data_gn.value = null;
      let node_id = 0;
      if (param.componentType == "xAxis") {
        node_id = levelOneNodes[param.value];
      } else if (param.componentType == "series") {
        node_id = levelOneNodes[param.name];
      }
      let twoNodePromiseList = contrastList.value.map((item) => {
        return new Promise((resolve, reject) => {
          getCarScoreV2({
            model_id: item.model_id,
            report_id: item.report_id,
            node_id,
          })
            .then((res) => {
              resolve(res);
            })
            .catch((res) => {
              reject(res);
            });
        });
      });
      let data = [];

      Promise.all(twoNodePromiseList).then((values) => {
        if (values && values.length > 0) {
          for (let item of values) {
            if (item.code == 200) {
              data.push(item.data);
            }
          }
          if (data && data.length > 0) {
            //横轴分类展示
            const lineName = [];
            // 车型分类展示
            const legendName = [];
            // 折线数值展示
            const lineValue = [];

            for (let [index, car] of contrastList.value.entries()) {
              legendName.push({ name: car.short_name || car.model_name, icon: "rect" });
              const carLineValue = {
                name: car.short_name || car.model_name,
                type: "line",
                data: [],
                symbol: "circle",
                symbolSize: 8,
                animation: false,
                label: {
                  show: true,
                },
              };
              for (let node_item of data[index].list) {
                if (lineName.indexOf(node_item.node_name) < 0) {
                  lineName.push(node_item.node_name);
                  levelTwoNodes[node_item.node_name] = node_item.node_id;
                }
                node_item.score_percentage = Number(
                  ((node_item.score / node_item.total_score) * 100).toFixed(1)
                );

                carLineValue.data.push({
                  label: {
                    color: "#404248",
                    fontSize: 12,
                    formatter: () => {
                      return node_item.score_percentage + "%";
                    },
                  },
                  value: node_item.score_percentage,
                });
              }
              lineValue.push(carLineValue);
            }
            //   清除画布
            // levelTwoChartRef.value && levelTwoChartRef.value.clear();
            setLineChartOptions2(legendName, lineName, lineValue);
          }
        }
      });
    };
    let xn_levelTwoNodes = {};
    let xn_levelTwoNodeChilds = {};
    const xn_levelOneClick = (param) => {
      xn_lineLoading2.value = true;
      xn_lineOptions3.value = null;
      tree_table_data_xn.value = null;
      let node_id = 0;
      if (param.componentType == "xAxis") {
        node_id = levelOneNodes[param.value];
      } else if (param.componentType == "series") {
        node_id = levelOneNodes[param.name];
      }
      let twoNodePromiseList = contrastList.value.map((item) => {
        return new Promise((resolve, reject) => {
          getCarScoreV2({
            model_id: item.model_id,
            report_id: item.report_id,
            node_id,
          })
            .then((res) => {
              resolve(res);
            })
            .catch((res) => {
              reject(res);
            });
        });
      });
      let data = [];

      Promise.all(twoNodePromiseList).then((values) => {
        if (values && values.length > 0) {
          for (let item of values) {
            if (item.code == 200) {
              data.push(item.data);
            }
          }
          if (data && data.length > 0) {
            //横轴分类展示
            const lineName = [];
            // 车型分类展示
            const legendName = [];
            // 折线数值展示
            const lineValue = [];

            for (let [index, car] of contrastList.value.entries()) {
              legendName.push({ name: car.short_name || car.model_name, icon: "rect" });
              const carLineValue = {
                name: car.short_name || car.model_name,
                type: "line",
                data: [],
                symbol: "circle",
                symbolSize: 8,
                animation: false,
                label: {
                  show: true,
                },
              };
              for (let node_item of data[index].list) {
                if (lineName.indexOf(node_item.node_name) < 0) {
                  lineName.push(node_item.node_name);
                  xn_levelTwoNodes[node_item.node_name] = node_item.node_id;
                  xn_levelTwoNodeChilds[node_item.node_name] = node_item.child;
                }
                node_item.score_percentage = Number(
                  ((node_item.score / node_item.total_score) * 100).toFixed(1)
                );

                carLineValue.data.push({
                  label: {
                    color: "#404248",
                    fontSize: 12,
                    formatter: () => {
                      return node_item.score_percentage + "%";
                    },
                  },
                  value: node_item.score_percentage,
                });
              }
              lineValue.push(carLineValue);
            }
            //   清除画布
            // xn_levelTwoChartRef.value && xn_levelTwoChartRef.value.clear();
            setLineChartOptions2(legendName, lineName, lineValue, "xn_1");
          }
        }
      });
    };
    const setLineChartOptions2 = (legendName, lineName, lineValue, which) => {
      console.log(`【setLineChartOptions2】开始设置图表选项，which=${which}`);
      console.log("【setLineChartOptions2】参数 - legendName:", legendName);
      console.log("【setLineChartOptions2】参数 - lineName:", lineName);
      console.log("【setLineChartOptions2】参数 - lineValue:", lineValue);
      
      let options = {
        tooltip: {
          trigger: "axis",
          enterable: true,
          confine: true,
          backgroundColor: "rgba(37, 34, 69, 0.8)",
          transitionDuration: 1,
          padding: [20, 30, 17, 30],
          position: function (point) {
            // 固定在顶部
            return [point[0], "20%"];
          },
          textStyle: {
            color: "#fff",
            fontSize: 14,
            lineHeight: 16,
          },
        },
        legend: {
          data: legendName,
          left: "center",
          itemWidth: 11,
          itemHeight: 11,
          itemGap: 25,
          itemStyle: {
            fontSize: 12,
          },
        },

        xAxis: {
          triggerEvent: true,
          type: "category",
          boundaryGap: false,
          data: lineName,
          nameLocation: "center",
          nameTextStyle: {
            color: "#404248",
            fontSize: 16,
          },
          axisLine: {
            lineStyle: {
              // color: "#b9c2da",
              width: "1", //坐标线的宽度
            },
          },
          axisLabel: {
                        color:"#2192ff",
            fontSize: 12,
          },
          offset: 20,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#404248",
            fontSize: 12,
            padding: [0, 30, 0, 0],
            formatter: "{value} %",
          },
          splitLine: {
            lineStyle: {
              color: "#edf2fe",
            },
          },
          splitNumber: 5,
          min: function (value) {
            return Math.floor(value.min / 10) * 10;
          },
          max: function (value) {
            return (Math.floor(value.max / 10) + 1) * 10 > 100
              ? 100
              : (Math.floor(value.max / 10) + 1) * 10;
          },
          interval: 10,
        },
        series: lineValue,
      };

      console.log(`【setLineChartOptions2】生成的options:`, options);
      console.log(`【setLineChartOptions2】options.series长度:`, options.series?.length);
      console.log(`【setLineChartOptions2】options.xAxis.data长度:`, options.xAxis.data?.length);

      if (which == "xn_1") {
        xn_lineOptions2.value = options;
        xn_lineLoading2.value = false;
        goAnthor(".echarts_item4");
      } else if (which == "xn_2") {
        xn_lineOptions3.value = options;
        xn_lineLoading3.value = false;
        goAnthor(".echarts_item6");
      } else {
        goAnthor(".echarts_item2");
        lineOptions2.value = options;
        lineLoading2.value = false;
      }
    };

    // 创新指标 条形图
    const setBarChartOptions = (legendName, barName, barValue) => {
      barOptions.value = {
        color:['#69a8f0', '#AEDAAE', '#b0d8f5', '#5cbe85', '#f2d0a7', '#e1b0bb', '#EAC0EA', '#fac858', '#ee6666'],
        legend: {
          data: legendName,
          left: "center",
          itemWidth: 11,
          itemHeight: 11,
          itemGap: 25,
          itemStyle: {
            fontSize: 12,
          },
        },
        label: {
          show: true,
          position: "top",
          color: "#404248",
          fontSize: 12,
          fontWeight: 600,
          rich: {
            scoreStyle: {
              fontWeight: "normal",
              fontSize: 14,
            },
          },
        },
        grid: {
          show: true,
          backgroundColor: "rgba(250, 250, 250, .6)",
          borderColor: "rgba(255, 255, 255, 1)",
        },
        tooltip: {
          trigger: "axis",
          enterable: true,
          confine: true,
          backgroundColor: "rgba(37, 34, 69, 0.8)",
          transitionDuration: 1,
          padding: [20, 30, 17, 30],
          position: function (point) {
            // 固定在顶部
            return [point[0], "20%"];
          },
          textStyle: {
            color: "#fff",
            fontSize: 14,
            lineHeight: 16,
          },
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: barName,
          axisLabel: {
            color:"#2192ff",
            fontSize: 12,
            padding: [0, 15, 0, 0],
            // formatter: "{valueStyle|{value}}\n{linkStyle|查看创新项目}",
            rich: {
              valueStyle: {
                color: "#404248",
                fontWeight: "bold",
                fontSize: 16,
              },
              linkStyle: {
                color: "#709AE8",
                fontSize: 12,
                align: "center",
                padding: [6, 0, 0, 0],
              },
            },
          },
          splitLine: {
            lineStyle: {
              color: "#edf2fe",
            },
          },
          triggerEvent: true,
        },
        yAxis: {
          axisLabel: {
            color: "#404248",
            fontSize: 12,
            padding: [0, 20, 0, 0],
            formatter: "{value}",
          },
          type: "value",
          boundaryGap: [0, 0.01],
        },
        series: barValue,
      };
    };
    const innovateClick = (param) => {
      innovate_treetable_data.value = [];
      innovate_treetable_loading.value = true;
      let node_id = 0;
      let node_name = "";
      if (param.componentType == "xAxis") {
        node_id = innovationNodes[param.value];
        node_name = param.value;
      } else if (param.componentType == "series") {
        node_id = innovationNodes[param.name];
        node_name = param.name;
      }
      getCarNodeData(
        {
          node_name,
          node_id,
        },
        "创新"
      );
    };

    // 功能二级
    const levelTwoChartRef = ref(null);
    const lineOptions2 = ref(null);
    const lineLoading2 = ref(false);
    const echartsClick2 = (param) => {
      tree_table_loading_gn.value = true;
      tree_table_data_gn.value = [];
      let node_id = 0;
      let node_name = "";
      if (param.componentType == "xAxis") {
        node_id = levelTwoNodes[param.value];
        node_name = param.value;
      } else if (param.componentType == "series") {
        node_id = levelTwoNodes[param.name];
        node_name = param.name;
      }
      getCarNodeData({
        node_id,
        node_name,
      });
    };

    // 性能二级
    const xn_levelTwoChartRef = ref(null);
    const xn_lineOptions2 = ref(null);
    const xn_lineLoading2 = ref(false);

    let xn_levelThreeNodes = {};
    let xn_levelThreeNodeChilds = {};
    const xn_echartsClick2 = (param) => {
      let node_id = 0;
      let node_name = "";
      let node_child = [];
      if (param.componentType == "xAxis") {
        node_id = xn_levelTwoNodes[param.value];
        node_name = param.value;
        node_child = xn_levelTwoNodeChilds[param.value];
      } else if (param.componentType == "series") {
        node_id = xn_levelTwoNodes[param.name];
        node_name = param.name;
        node_child = xn_levelTwoNodeChilds[param.name];
      }
      let is_leaf_node = false;
      node_child.forEach((item) => {
        if (item.is_leaf == 1) {
          is_leaf_node = true;
        }
      });
      if (is_leaf_node) {
        xn_lineOptions3.value = null;
        tree_table_loading_xn.value = true;
        tree_table_data_xn.value = [];
        getCarNodeData(
          {
            node_id,
            node_name,
          },
          "性能"
        );
      } else {
        xn_lineLoading3.value = true;
        tree_table_data_xn.value = null;
        let threeNodePromiseList = contrastList.value.map((item) => {
          return new Promise((resolve, reject) => {
            getCarScoreV2({
              model_id: item.model_id,
              report_id: item.report_id,
              node_id,
            })
              .then((res) => {
                resolve(res);
              })
              .catch((res) => {
                reject(res);
              });
          });
        });
        let data = [];
        Promise.all(threeNodePromiseList).then((values) => {
          if (values && values.length > 0) {
            for (let item of values) {
              if (item.code == 200) {
                data.push(item.data);
              }
            }
            if (data && data.length > 0) {
              //横轴分类展示
              const lineName = [];
              // 车型分类展示
              const legendName = [];
              // 折线数值展示
              const lineValue = [];

              for (let [index, car] of contrastList.value.entries()) {
                legendName.push({ name: car.short_name || car.model_name, icon: "rect" });
                const carLineValue = {
                  name: car.short_name || car.model_name,
                  type: "line",
                  data: [],
                  symbol: "circle",
                  symbolSize: 8,
                  animation: false,
                  label: {
                    show: true,
                  },
                };
                for (let node_item of data[index].list) {
                  if (lineName.indexOf(node_item.node_name) < 0) {
                    lineName.push(node_item.node_name);
                    xn_levelThreeNodes[node_item.node_name] = node_item.node_id;
                    xn_levelThreeNodeChilds[node_item.node_name] =
                      node_item.child;
                  }
                  node_item.score_percentage = Number(
                    ((node_item.score / node_item.total_score) * 100).toFixed(1)
                  );

                  carLineValue.data.push({
                    label: {
                      color: "#404248",
                      fontSize: 12,
                      formatter: () => {
                        return node_item.score_percentage + "%";
                      },
                    },
                    value: node_item.score_percentage,
                  });
                }
                lineValue.push(carLineValue);
              }
              //   清除画布
              // xn_levelThreeChartRef.value && xn_levelThreeChartRef.value.clear();
              setLineChartOptions2(legendName, lineName, lineValue, "xn_2");
            } else {
              console.warn("【性能三级】data为空或长度为0");
            }
          } else {
            console.warn("【性能三级】values为空或长度为0");
          }
        });
      }
    };

    // 性能三级
    const xn_levelThreeChartRef = ref(null);
    const xn_lineOptions3 = ref(null);
    const xn_lineLoading3 = ref(false);
    const xn_echartsClick3 = (param) => {
      tree_table_loading_xn.value = true;
      tree_table_data_xn.value = [];
      let node_id = 0;
      let node_name = "";
      if (param.componentType == "xAxis") {
        node_id = xn_levelThreeNodes[param.value];
        node_name = param.value;
      } else if (param.componentType == "series") {
        node_id = xn_levelThreeNodes[param.name];
        node_name = param.name;
      }
      getCarNodeData(
        {
          node_id,
          node_name,
        },
        "性能"
      );
    };

    // 表格
    const tree_table_data_gn = ref(null);
    const tree_table_loading_gn = ref(false);
    // const tree_table_data_xn = ref(null);
    const tree_table_loading_xn = ref(false);
    const tree_table_data_lt = ref(null);
    const tree_table_loading_lt = ref(false);
    const innovate_treetable_data = ref(null);
    const innovate_treetable_loading = ref(false);
    const getCarNodeData = (node_info, type) => {
      if (type == "创新") {
        let promise_list = contrastList.value.map((item) => {
          return new Promise((resolve, reject) => {
            getCarScoreInnovateV2({
              report_id: item.report_id,
              model_id: item.model_id,
              type: node_info.node_id,
            })
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          });
        });
        Promise.all(promise_list).then((res_list) => {
          var list = hebing(
            res_list.map((res) => {
              return res.data;
            }),
            true
          );
          list.forEach((childs) => {
            childs.child = chenggenb(childs.child, childs.name);
          });
          if (list.length < 1) {
            list = [
              {
                child: [],
                name: node_info.node_name,
                node_id: node_info.node_id,
                score: {},
                total_score: {},
              },
            ];
          }
          innovate_treetable_data.value = list;
          innovate_treetable_loading.value = false;
          goAnthor(".analyse_item_table3");
        });
      } else if (type == "性能") {
        const promise_list = contrastList.value.map((item) => {
          return new Promise((resolve, reject) => {
            getCarScoreV2({
              report_id: item.report_id,
              model_id: item.model_id,
              node_id: node_info.node_id,
              need_own: 1,
            })
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          });
        });
        Promise.all(promise_list)
          .then((res_list) => {
            var list = hebing(
              res_list.map((res) => {
                return res.data.list;
              })
            );
            tree_table_data_xn.value = list;
            tree_table_loading_xn.value = false;
            goAnthor(".echarts_item5");
          })
          .catch(() => {
            ElMessage({
              showClose: true,
              message: "分析数据拉取失败，请重试!",
              type: "warning",
            });
            return;
          });
      } else if (type == "旅途") {
        const promise_list = contrastList.value.map((item) => {
          return new Promise((resolve, reject) => {
            getCarScoreV2({
              report_id: item.report_id,
              model_id: item.model_id,
              node_id: node_info.node_id,
              need_own: 1,
            })
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          });
        });
        Promise.all(promise_list)
          .then((res_list) => {
            var list = hebing(
              res_list.map((res) => {
                return res.data.list;
              })
            );
            tree_table_data_lt.value = list;
            tree_table_loading_lt.value = false;
            goAnthor(".echarts_item9");
          })
          .catch(() => {
            ElMessage({
              showClose: true,
              message: "分析数据拉取失败，请重试!",
              type: "warning",
            });
            return;
          });
      } else {
        const promise_list = contrastList.value.map((item) => {
          return new Promise((resolve, reject) => {
            getCarScoreV2({
              report_id: item.report_id,
              model_id: item.model_id,
              node_id: node_info.node_id,
              need_own: 1,
            })
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          });
        });
        Promise.all(promise_list)
          .then((res_list) => {
            var list = hebing(
              res_list.map((res) => {
                return res.data.list;
              })
            );
            tree_table_data_gn.value = list;
            tree_table_loading_gn.value = false;
            goAnthor(".echarts_item3");
          })
          .catch(() => {
            ElMessage({
              showClose: true,
              message: "分析数据拉取失败，请重试!",
              type: "warning",
            });
            return;
          });
      }
    };
    // 创新的表格合并函数
    const objectSpanMethod = ({ row, columnIndex }) => {
      if (columnIndex === contrastList.value.length + 1) {
        if (!("child" in row)) {
          if (row.set_arr && row.set_arr.length) {
            return {
              rowspan: row.set_arr.length,
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 1,
            };
          }
        } else {
          return {
            rowspan: 1,
            colspan: 1,
          };
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
    };
    // 更换或添加车型
    const changeModel = ({ type, model_id }) => {
      if (type == "add") {
        router.push({
          path: "/v2/report/change_model",
          query: {
            not_in_id: contrastList.value
              .map((item) => {
                return item.model_id;
              })
              .join(","),
          },
        });
      } else if (type == "del") {
        store.deleteCompareCarDataV2(model_id);
        // contrastList.value = store.getCompareCarDataV2()
        xn_lineOptions2.value = null;
        xn_lineOptions3.value = null;
        tree_table_data_xn.value = null;

        lineOptions2.value = null;
        innovate_treetable_data.value = null;
        tree_table_data_gn.value = null;
        // l2_node_id.value = null;
        // l3_node_id.value = null;
        tree_table_data_lt.value = null;

        _getData();
      }
    };

    const descDrawer = ref(false);
    const node_name = ref("");
    const evaluation_type = ref("");
    const evaluation_list = ref([]);
    const getEvaluation = (row, type) => {
      evaluation_type.value = type;
      node_name.value = row.node_name || row.name;
      let node_id = row.node_id || row.id;
      let cur_list = [];
      cur_list = contrastList.value;
      let promise_list2 = cur_list.map((item) => {
        return new Promise((resolve, reject) => {
          getTestDetailV2({
            report_id: item.report_id,
            model_id: item.model_id,
            node_id: node_id,
          })
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
      Promise.all(promise_list2).then((res_list) => {
        evaluation_list.value = res_list.map((res) => {
          let item_value = {};
          if (res.data) {
            item_value = {
              node_name: res.data.node_name,
              node_value: res.data.node_value,
            };
          }
          return item_value;
        });
        descDrawer.value = true;
      });
    };
    // 详情弹窗数据展示列表
    const detail_list = ref([]);
    // 详情弹窗控制
    const dialogVisible = ref(false);
    //获取详情数据
    const getDetail = (row) => {
      node_name.value = row.node_name || row.name;
      let node_id = row.node_id || row.id;
      let cur_list = [];
      cur_list = contrastList.value;

      let promise_list2 = cur_list.map((item) => {
        return new Promise((resolve, reject) => {
          getTestDetailV2({
            report_id: item.report_id,
            model_id: item.model_id,
            node_id: node_id,
          })
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
      Promise.all(promise_list2).then((res_list) => {
        detail_list.value = res_list.map((res) => {
          let item_value = {};
          if (res.data && res.data.item_value) {
            res.data.item_value.forEach((item) => {
              item_value[item.item_value_val_type] = item;
            });
            item_value["9"] = res.data["node_desc"];
          }
          return item_value;
        });
        dialogVisible.value = true;
      });
    };
    const drawer = ref(false);
    // 创新数据列表
    const innovate_detail_list = ref([]);
    const innovate_detail_list_cur_type = ref("");
    const innovate_first_key = ref(0);
    //获取创新项目详情数据
    const getInnovateDetailV2Info = (row) => {
      innovate_detail_list_cur_type.value = row.parent_name;
      let node_id = row.set_arr.join("-") || row.id;
      let new_set_model_list = contrastList.value;
      const resp = new Map();
      new_set_model_list = new_set_model_list.filter(
        (new_set_model_list) =>
          !resp.has(new_set_model_list.model_id) &&
          resp.set(new_set_model_list.model_id, 1)
      );
      let promise_list3 = new_set_model_list.map((item) => {
        return new Promise((resolve, reject) => {
          getInnovateDetailV2({
            report_id: item.report_id,
            model_id: item.model_id,
            node_ids: node_id,
          })
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      });
      Promise.all(promise_list3).then((res_list) => {
        let set_ind = 0;
        let set_add = 1;
        let prev_review_tree_name = "";
        innovate_detail_list.value = res_list
          .map((res, ind) => {
            let item_value = {};
            if (res.data && res.data.length) {
              item_value = res.data;
              item_value.model_name = contrastList.value[ind].model_name;
              item_value.model_id = contrastList.value[ind].model_id;
              item_value.model_img = contrastList.value[ind].model_img;
              res.data = res.data.map((item, index) => {
                let item_item_val = {};
                item.item.forEach((item_item) => {
                  item_item_val[item_item.item_value_type] = item_item;
                });
                item.item = item_item_val;
                if (item.review_tree_name != prev_review_tree_name) {
                  prev_review_tree_name = item.review_tree_name;
                  res.data[set_ind].hebing = set_add;
                  set_ind = index;
                  set_add = 1;
                } else {
                  item.hebing = 0;
                  set_add++;
                }
                return item;
              });
              res.data[set_ind].hebing = set_add;
              return item_value;
            } else {
              item_value = null;
            }
          })
          .filter((item) => {
            return item;
          });
        for (let key in innovate_detail_list.value) {
          if (innovate_detail_list.value[key] != null) {
            innovate_first_key.value = key;
            break;
          }
        }
        drawer.value = true;
        // dialogVisible.value= true;
      });
    };

    const swiperVisible = ref(false);
    const preview_list = ref([]);
    const preview_type = ref("img");
    const previewImg = (list, type) => {
      preview_list.value = list;
      preview_type.value = type;
      swiperVisible.value = true;
    };

    const closeSwiperDialog = () => {
      document.querySelectorAll("video").forEach((item) => {
        item.pause();
      });
      swiperVisible.value = false;
    };
    const showRuleDesc = ref(false);

    // 旅途一级
    const l1_node_id_lt = ref(4574);
    const l1_node_name_lt = ref("旅途指标");
    const l1_click_lt = (node) => {
      l2_node_id_lt.value = node.node_id;
      l2_node_name_lt.value = node.node_name;
      l3_node_id_lt.value = 0;
      tree_table_data_lt.value = null;
    };
    // 旅途二级
    const l2_node_id_lt = ref(null);
    const l2_node_name_lt = ref("");
    const l2_click_lt = (node) => {
      l3_node_id_lt.value = node.node_id;
      l3_node_name_lt.value = node.node_name;
      tree_table_data_lt.value = null;
    };
    // 旅途三级
    const l3_node_id_lt = ref(null);
    const l3_node_name_lt = ref("");
    const l3_click_lt = (node) => {
      l4_node_name_lt.value = node.node_name;
      tree_table_data_lt.value = [];
      tree_table_loading_lt.value = true;
      getCarNodeData(node, "旅途");
    };
    const l4_node_name_lt = ref("");

    // 性能一级
    const l1_node_id_xn = ref(4227);
    const l1_node_name_xn = ref("性能指标");
    const l1_click_xn = (node) => {
      l2_node_id_xn.value = node.node_id;
      l2_node_name_xn.value = node.node_name;
      l3_node_id_xn.value = 0;
      tree_table_data_xn.value = null;
    };
    // 性能二级
    const l2_node_id_xn = ref(null);
    const l2_node_name_xn = ref(null);
    const l2_click_xn = (node) => {
      l3_node_id_xn.value = node.node_id;
      l3_node_name_xn.value = node.node_name;
      tree_table_data_xn.value = null;
    };
    // 性能三级
    const l3_node_id_xn = ref(null);
    const l3_node_name_xn = ref(null);
    const l3_click_xn = (node) => {
      // getTableData(node)
      l4_node_name_xn.value = node.node_name;
      tree_table_data_xn.value = [];
      tree_table_loading_lt.value = true;
      getCarNodeData(node, "性能");
    };
    const l4_node_name_xn = ref("");
    const tree_table_data_xn = ref(null);
    // 功能一级
    const l1_node_id_gn = ref(4921);
    const l1_node_name_gn = ref("功能指标");
    const l1_click_gn = (node) => {
      l2_node_id_gn.value = node.node_id;
      l2_node_name_gn.value = node.node_name;
      tree_table_data_gn.value = null;
    };
    // 功能二级
    const l2_node_id_gn = ref(null);
    const l2_node_name_gn = ref(null);
    const l2_click_gn = (node) => {
      l3_node_name_gn.value = node.node_name;
      tree_table_data_gn.value = [];
      tree_table_loading_gn.value = true;
      getCarNodeData(node, "功能");
    };
    // 功能三级
    const l3_node_name_gn = ref(null);

    /*---------表格合并单元格---------*/
    function chenggenb(list, parent_name) {
      let set_ind = 0,
        set_arr = [],
        col_ind = 0;
      list = JSON.parse(JSON.stringify(list));
      list.forEach((row_item, row_ind) => {
        for (let i = 0; i < contrastList.value.length; i++) {
          if (row_item.score[i] > -1) {
            //如果有分数，并且和上一次的col_ind相等，就往set_arr里面push(row_item.node_id),
            //          不相等的话，就改变col_ind的值 并且重置新的set_arr= [row_item.node_id];
            //              当前下标小于col_ind 说明要重置新的set_arr= [row_item.node_id]
            if (i != col_ind) {
              list[set_ind]["set_arr"] = set_arr;
              list[set_ind]["parent_name"] = parent_name;
              set_arr = [];
              set_arr.push(row_item.node_id);
              set_ind = row_ind;
              col_ind = i;
              break;
            } else {
              set_arr.push(row_item.node_id);
              break;
            }
          }
          if (!(row_item.score[i] > -1) && i == contrastList.value.length - 1) {
            list[set_ind]["set_arr"] = set_arr;
            list[set_ind]["parent_name"] = parent_name;
            set_arr = [];
            set_ind = row_ind;
            col_ind = -1;
          }
        }
        if (row_ind == list.length - 1) {
          list[set_ind]["set_arr"] = set_arr;
          list[set_ind]["parent_name"] = parent_name;
        }
      });
      return list;
    }
    /*---------表格合并单元格---------*/
    /*---------合并树数据---------*/
    let scoreMap = {},
      childMap = {},
      nodeMap = {},
      count = 0;
    function hebing(data, is_cx) {
      count = data.length;
      let listMap = {};
      for (let k in data) {
        let list = data[k];
        for (let dd in list) {
          let d = JSON.parse(JSON.stringify(list[dd]));
          listMap[d["node_id"]] = mapList(d, k);
          setScoreMap(d["node_id"], d["total_score"], d["score"], k);
          nodeMap[d["node_id"]] = d;
        }
      }
      let tmpList = [];
      Object.values(listMap).forEach((l) => {
        l["total_score"] = fillArray(scoreMap[l["node_id"]]["total_score"]);
        l["score"] = fillArray(scoreMap[l["node_id"]]["score"]);
        tmpList.push(l);
      });
      let tree_list = rebuild(tmpList);
      scoreMap = {};
      childMap = {};
      nodeMap = {};
      count = 0;

      if (!is_cx) {
        let newMap = {};
        let result_list = [];
        // 收集所有节点的映射
        for (let ti in tree_list) {
          newMap[tree_list[ti]["node_id"]] = tree_list[ti];
        }
        // 收集所有车辆的所有节点ID，确保不遗漏任何节点
        let allNodeIds = new Set();
        for (let k in data) {
          let list = data[k];
          for (let dd in list) {
            allNodeIds.add(list[dd]["node_id"]);
          }
        }
        // 先按照 data[0] 的顺序添加节点
        let addedNodeIds = new Set();
        for (let di in data[0]) {
          let nodeId = data[0][di]["node_id"];
          if (newMap[nodeId]) {
            result_list.push(newMap[nodeId]);
            addedNodeIds.add(nodeId);
          }
        }
        // 补充其他车辆独有的节点（不在 data[0] 中的节点）
        for (let nodeId of allNodeIds) {
          if (!addedNodeIds.has(nodeId) && newMap[nodeId]) {
            result_list.push(newMap[nodeId]);
          }
        }
        return result_list;
      } else {
        return tree_list;
      }
    }
    function rebuild(list) {
      let exitsArr = {};
      let newArr = Array();
      for (let key in list) {
        let l = list[key];
        if (!exitsArr[l["node_id"]]) {
          exitsArr[l["node_id"]] = true;
          if (childMap[l["node_id"]]) {
            let childList = [];
            for (let ckey in childMap[l["node_id"]]) {
              let c = childMap[l["node_id"]][ckey];
              let child = nodeMap[c];
              child["total_score"] = fillArray(
                scoreMap[child["node_id"]]["total_score"]
              );
              child["score"] = fillArray(scoreMap[child["node_id"]]["score"]);
              childList.push(child);
            }
            l["child"] = rebuild(childList);
          }
          newArr.push(l);
        }
      }
      return newArr;
    }
    function fillArray(arr) {
      for (let i = 0; i < count; i++) {
        if (typeof arr[i] == "undefined") {
          arr[i] = -1;
        }
      }
      return arr;
    }
    function mapList(list2, k) {
      let childlist2 = list2["child"];
      if (!childlist2) {
        return;
      }
      list2["child"] = {};
      if (childlist2.length > 0 || Object.keys(childlist2).length > 0) {
        for (let k1 in childlist2) {
          let child = childlist2[k1];
          if (
            !childMap[list2["node_id"]] ||
            childMap[list2["node_id"]].indexOf(child["node_id"]) == -1
          ) {
            if (!childMap[list2["node_id"]]) {
              childMap[list2["node_id"]] = [];
            }
            childMap[list2["node_id"]].push(child["node_id"]);
          }
          setScoreMap(
            child["node_id"],
            child["total_score"],
            child["score"],
            k
          );
          list2["child"] = {};
          list2["child"][child["node_id"] + ""] = mapList(child, k);
          nodeMap[child["node_id"]] = child;
        }
      } else {
        setScoreMap(list2["node_id"], list2["total_score"], list2["score"], k);
      }
      return list2;
    }
    function setScoreMap(node_id, total_score, score, k) {
      if (!scoreMap[node_id]) {
        scoreMap[node_id] = {};
      }
      if (!scoreMap[node_id]["total_score"]) {
        scoreMap[node_id]["total_score"] = {};
      }
      if (!scoreMap[node_id]["score"]) {
        scoreMap[node_id]["score"] = {};
      }
      scoreMap[node_id]["total_score"][k] = total_score;
      scoreMap[node_id]["score"][k] = score;
    }
    /*---------合并树数据---------*/

    const goAnthor = (selector) => {
      setTimeout(() => {
        const height = document.querySelector(selector).offsetTop;
        const container = document.querySelector(".el-main");
        container.scrollTo({
          top: selector == ".analyse_item_table3" ? height - 150 : height + 170,
          behavior: "smooth",
        });
      }, 100);
    };

    const downloadFn = (list,model_name,node_name)=>{
      store.addDownload(list,model_name,node_name);
      ElMessage.success("已添加到下载队列中")
    }
    return {
      // 车型列表
      contrastList,
      // tab切换
      cur_tab_ind,
      changeTab,
      // 功能一级
      lineOptions,
      lineLoadingOptions,
      lineLoading,
      levelOneClick,
      levelOneChartRef,
      // 二级
      lineOptions2,
      lineLoading2,
      echartsClick2,
      levelTwoChartRef,

      //性能一级
      xn_lineOptions,
      xn_lineLoading,
      xn_levelOneClick,
      xn_levelOneChartRef,
      // 二级
      xn_lineOptions2,
      xn_lineLoading2,
      xn_echartsClick2,
      xn_levelTwoChartRef,
      // 三级
      xn_lineOptions3,
      xn_lineLoading3,
      xn_echartsClick3,
      xn_levelThreeChartRef,
      // 表格
      // tree_table_data_xn,
      // xn_tree_table_loading,

      // 创新
      barOptions,
      barLoadingOptions,
      barLoading,
      innovateClick,
      innovateChartRef,

      // 旅途
      l1_node_id_lt,
      l1_node_name_lt,
      l1_click_lt,
      l2_node_id_lt,
      l2_node_name_lt,
      l2_click_lt,
      l3_node_id_lt,
      l3_node_name_lt,
      l3_click_lt,
      l4_node_name_lt,
      tree_table_data_lt,
      tree_table_loading_lt,
      // 性能
      l1_node_id_xn,
      l1_node_name_xn,
      l1_click_xn,
      l2_node_id_xn,
      l2_node_name_xn,
      l2_click_xn,
      l3_node_id_xn,
      l3_node_name_xn,
      l3_click_xn,
      l4_node_name_xn,
      tree_table_data_xn,
      tree_table_loading_xn,
      // 功能
      l1_node_id_gn,
      l1_node_name_gn,
      l1_click_gn,
      l2_node_id_gn,
      l2_node_name_gn,
      l2_click_gn,
      l3_node_name_gn,

      goAnthor,

      // 表格
      tree_table_data_gn,
      tree_table_loading_gn,
      innovate_treetable_data,
      innovate_treetable_loading,
      objectSpanMethod,

      changeModel,

      getEvaluation,
      getDetail,
      node_name,
      evaluation_type,
      evaluation_list,
      descDrawer,
      dialogVisible,
      detail_list,
      preview_list,
      preview_type,
      previewImg,
      swiperVisible,
      showRuleDesc,

      drawer,
      innovate_detail_list,
      getInnovateDetailV2Info,
      closeSwiperDialog,
      innovate_detail_list_cur_type,
      innovate_first_key,

      downloadFn,
      store
    };
  },
};
</script>
<style scoped lang="less">
.compare_models_top {
  align-items: center;
  padding: 20px 60px 0;
  .compare_title {
    width: 120px;
    height: 100px;
    .compare_title_left {
      width: 5px;
      height: 19px;
      background: #1fbcbf;
      border-radius: 2px;
    }
    .compare_title_text {
      font-size: 16px;
      color: #404e5b;
      line-height: 19px;
      margin-left: 16px;
    }
  }
  .compare_models {
    align-items: center;
    padding: 0 13px 0 30px;
    .compare_model {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 250px;
      position: relative;
      .compare_model_img {
        width: 160px;
        height: 90px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .compare_model_name {
        height: 21px;
        font-size: 14px;
        color: #404248;
        line-height: 21px;
        align-items: center;
        justify-content: center;
        .compare_model_name_text {
          max-width: 190px;
        }
      }
      .compare_model_del_btn {
        width: 42px;
        height: 42px;
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/cepingliebiao_del.png)
          no-repeat center center;
        background-size: 21px 21px;
        cursor: pointer;
      }
    }
  }
  // .compare_model_add_btn {
  //   margin-left: 34px;
  //   width: 132px;
  //   height: 42px;
  //   background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/compare_btn_20230104.png)
  //     no-repeat center center;
  //   background-size: 100% 100%;
  //   cursor: pointer;
  // }
  .add_model_btn {
    cursor: pointer;
    margin-left: 34px;
    width: 132px;
    height: 42px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid #ADADAD;
    display: flex;
    justify-content: center;
    align-items: center;
    .addText {
      font-size: 14px;
      color: #36474F;
      line-height: 21px;
    }
    .addIcon {
      width: 21px;
      height: 21px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/add_20230105.svg) no-repeat;
      margin-right: 11px;
    }
  }
}
.tabs {
  height: 42px;
  margin: 50px 60px 0;
  border-bottom: 1px solid #d4d4d4;
  .tab {
    cursor: pointer;
    width: 160px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    font-size: 17px;
    color: #0e0a31;
    &.act {
      font-weight: bold;
      border-bottom: solid 2px #1fbcbf;
    }
  }
}
.white_bg {
  border-radius: 0 10px 10px 10px;
}
.contents {
  .content {
    padding-bottom: 50px;
    .echarts_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      padding: 40px 0 0 50px;
    }
  }
}
.tree_table_content {
  padding: 40px 50px;
  overflow: hidden;
  .model_list_box {
    // width: 100%;
    display: flex;
    align-items: center;
    border: solid 1px #dde5fd;
    border-radius: 4px 4px 0 0;
    border-bottom: none;
    .model_list_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 80px;
      &.model_list_attr {
        font-size: 18px;
        color: #979797;
      }
      .model_attr {
        font-size: 14px;
        color: #979797;
        line-height: 30px;
      }
      .model_name {
        font-size: 14px;
        font-weight: bold;
        color: #474747;
        line-height: 20px;
        padding: 0 10px;
      }
    }
  }
}

.one_evaluation_desc {
  max-width: 600px;
  padding: 0 50px;

  .one_desc_tit {
    height: 70px;
    line-height: 70px;
    font-size: 24px;
    font-weight: bold;
    color: #2b2b2b;
  }
  .one_desc_desc {
    font-size: 18px;
    font-weight: 400;
    color: #777c89;
    line-height: 30px;
  }
}
.more_evaluation_desc {
  padding: 0 10px;
  .table3 {
    border-collapse: collapse;
    td {
      &.table_bd_left {
        border-left: 1px solid #dee6f2;
        &:first-child {
          border: none;
        }
      }
      & > div {
        width: 350px;
        text-align: center;
      }
      .table3_model_name {
        height: 90px;
        font-size: 16px;
        font-weight: bold;
        color: #474747;
        line-height: 24px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .table_title_text {
        height: 32px;
        background: #f5f8fc;
        font-size: 12px;
        font-weight: bold;
        color: #474747;
        line-height: 32px;
      }
      .table3_model_desc {
        padding: 40px 30px 10px;
        font-size: 14px;
        color: #777c89;
        line-height: 20px;
        .table3_model_content {
          text-align: left;
          white-space: pre-line;
        }
        .table3_model_experts,
        .table3_model_time {
          text-align: right;
          margin-top: 12px;
        }
      }
    }
  }
}

.detail_val_text {
  padding: 16px 17px;
  white-space: pre-line;
}
.no_img {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #777c89;
}
.detail_val_pic {
  display: flex;
  align-items: center;
  .detail_pic_left {
    width: 73px;
    height: 80px;
    cursor: pointer;
    .detail_pic_left_img {
      width: 73px;
      height: 60px;
      position: relative;
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .more_pic {
        width: 20px;
        height: 25px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: center;
        list-style: 25px;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
  .detail_pic_right {
    font-size: 12px;
    font-weight: bold;
    color: #777c89;
    line-height: 16px;
  }
}
.detail_val_video {
  display: flex;
  align-items: center;
  .detail_video_left {
    width: 92px;
    height: 84px;
    cursor: pointer;
    .detail_pic_left_video {
      width: 92px;
      height: 64px;
      position: relative;
      video {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
      .more_pic {
        width: 20px;
        height: 25px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: center;
        list-style: 25px;
        font-size: 13px;
        font-weight: bold;
        color: #ffffff;
      }
    }
    .look_pic {
      width: 100%;
      height: 16px;
      font-size: 12px;
      color: #5287ea;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.look_pic {
  width: 100%;
  height: 16px;
  font-size: 12px;
  color: #5287ea;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.my_swiper_dialog {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 5000;
  .my_swiper_dialog_content {
    width: auto;
    height: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .my_swiper_dialog_close {
      width: 50px;
      height: 50px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/a467vc54678bvt67bv.png)
        no-repeat center center;
      background-size: 50px 50px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 40px;
      position: absolute;
      top: 40px;
      right: 40px;
      z-index: 2;
      cursor: pointer;
    }
  }
}

.my_dialog {
  width: auto;
  height: auto;
  background: #fff;
  border-radius: 15px;
  padding: 10px;
  max-width: 90vw;
  height: calc(100vh - 75px);
  overflow-x: auto;
  overflow-y: auto;
  z-index: 99;
}
.tree_table_score {
  text-align: center;
}
.tree_table_score_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .tree_table_score {
    font-size: 12px;
    line-height: 20px;
    .tree_table_score_attr {
      color: #8791b2;
    }
    .tree_table_score_val {
      color: #474747;
    }
  }
  .tree_table_percent {
    font-size: 12px;
    color: #474747;
    line-height: 20px;
  }
}
.level_tag {
  display: inline-block;
  width: 83px;
  height: 18px;
  border-radius: 9px;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
  line-height: 18px;
  margin: 0 10px;
}
.color_E7816E {
  color: #e7816e;
}
.appraise_two_tag,
.detail_tag {
  width: 100%;
  height: 100%;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.detail_table2 {
  border-collapse: collapse;
  tr {
    background: #fff;
    td {
      border: 1px solid #dee6f2;
      text-align: center;
      padding: 10px;
    }
  }

  .table_tit {
    td {
      height: 44px;
    }
  }
  .td_model_info {
    width: 130px;
    .table_model_img {
      width: 100%;
      height: auto;
      img {
        width: 100%;
        height: auto;
      }
    }
    .table_model_name {
      margin-top: 10px;
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      color: #474747;
      line-height: 16px;
    }
  }
  .td_node_name {
    width: 100px;
    font-size: 12px;
    font-weight: bold;
    color: #474747;
  }
  .td_score {
    width: 110px;
    font-size: 12px;
    color: #474747;
    line-height: 20px;
  }
  .td_score_two {
    width: 80px;
    font-size: 12px;
    color: #578ae9;
  }
  .td_node_two {
    width: 105px;
    font-size: 12px;
    font-weight: bold;
    color: #474747;
  }
  .td_evaluation {
    max-width: 480px;
    text-align: left;
    white-space: pre-line;
    p {
      padding: 10px;
      font-size: 12px;
      color: #777c89;
      line-height: 16px;
    }
  }
}

:deep(.el-table__body-wrapper) {
  overflow-x: hidden;
  overflow-y: hidden;
}
:deep(.el-table__header thead tr th .cell) {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #474747;
}
.has_child_row {
  text-align: center;
}
:deep(.td_class) {
  position: relative;
}
:deep(.td_class .cell) {
  text-align: center;
  font-size: 16px;
  color: #709ae8;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
:deep(.el-progress-bar__innerText) {
  color: #000;
}

:deep(.modal_transparent) {
  background: transparent;
}

:deep(.el-drawer__body) {
  overflow-y: auto;
}
</style>